import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const StyledGrid = styled(Grid)({}) as typeof Grid;
